import ITemperatures from '../interfaces/Temperatures';
import { objHasEmptyProp } from './objHasEmptyProp';

interface TemperatureEnableObject {
  temperatures: ITemperatures;
  isRequired: boolean;
}
interface ErrorValidationsObj {
  tempMin?: any;
  tempMinF?: any;
  tempMax?: any;
  tempMaxF?: any;
}

export const isDisabledSaveButtonEdit = (
  temperatureObj: TemperatureEnableObject[] = [],
  ...errorValidations: ErrorValidationsObj[]
) => {
  const notFilledForm = temperatureObj
    .filter(t => t.isRequired)
    .some(t => objHasEmptyProp(t.temperatures));

  const hasAnyError = errorValidations.some(errors => {
    for (const temp in errors) {
      if (Object.keys(errors[temp]).some(e => errors[temp][e])) {
        return true;
      }
    }
  });
  return hasAnyError || notFilledForm;
};
